import React from 'react';
import Reco from '../../components/Reco';
import api from '../../services/api';


export default class Reconhecimento extends React.Component{
  state={
    allInfo: [],
    subInfo: [],
  }
  componentDidMount(){
    this.info();
  }

  info = async () => {
    const res = await api.get('/categoria/getJson');

    this.setState({allInfo: res.data["Reconhecimento de Estudos"], subInfo: res.data["Reconhecimento de Estudos"].Info});  
  }

  render(){
    window.scrollTo(0, 0);
    return(
      <>
        <Reco dados={this.state.allInfo} dados1={this.state.subInfo}/>
      </>
    )
  }
}